import { render, staticRenderFns } from "./OurWorkPageTwo.vue?vue&type=template&id=8846cb8c&"
import script from "./OurWorkPageTwo.vue?vue&type=script&lang=js&"
export * from "./OurWorkPageTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OurWorkPageTwo.vue"
export default component.exports